import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Container } from './styles';

const Button = ({ isDisabled, className, children, onClick, isBordered }) => (
  <Container
    disabled={isDisabled}
    className={cx(
      'submit-button',
      {
        ['submit-button--disabled']: isDisabled,
        ['submit-button--bordered']: isBordered
      },
      className
    )}
    onClick={onClick}
  >
    {children}
  </Container>
);

Button.propTypes = {
  isDisabled: PropTypes.bool,
  isBordered: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};

export default Button;
